_               = require 'underscore'
React           = require 'react'
Xrespond        = require '../scripts/xrespond'
DeviceStore     = require '../scripts/device_store'
ToggleExpanded  = require '../mixins/toggle_expanded'
DropdownDevices = require '../components/dropdown_devices'
Frame           = require '../components/frame'

module.exports = Device = React.createClass
  mixins: [ ToggleExpanded ]

  getInitialState: ->
    expanded: false

  componentWillMount: ->
    DeviceStore.registerAndInvoke @_update
    document.addEventListener 'keydown', @handleEscKey, false

  componentWillUnmount: ->
    DeviceStore.deregister @_update
    document.removeEventListener 'keydown', @handleEscKey, false

  _update: (devices) ->
    that = @ # @todo is @still necessary?
    device = _.filter devices, (d, index) -> index == that.props.id
    @setState _.extend({}, device[0], expanded: false)

  handleDropdownSubmit: (attrs) ->
    DeviceStore.update _.extend({}, attrs, id: @props.id)
    @toggleExpanded()

  toggleRotated: ->
    DeviceStore.update
      id: @props.id
      width: @state.height
      height: @state.width

  handleEscKey: (event) ->
    if @state.expanded && event.keyCode == 27 # Escape key
      @setState expanded: false
      @refs.dropdownButton.focus()

  render: ->
    dropdownDevices =
      if (@state.expanded) then React.createElement(DropdownDevices, {"reset": (false), "id": (@props.id), "devices": (Xrespond.devices_grouped()), "handleSubmit": (@handleDropdownSubmit), "handleBlur": (@toggleExpanded)})
      else ''

    rotate_button = React.createElement("button", {"className": "button button--medium button--square button--secondary button-group__button", "onClick": (@toggleRotated)},
                      React.createElement("svg", {"className": "icon icon--large"},
                        React.createElement("title", null, "Rotate screen"),
                        React.createElement("use", {"xlinkHref": "images/icons.svg#icon-rotate-left"})
                      )
                    )

    React.createElement("article", {"className": "device"},
      React.createElement("div", {"className": "device__wrap"},
        React.createElement("div", {"className": "device-control"},
          React.createElement("div", {"className": "button-group"},
            React.createElement("button", {"className": "button button--medium button--secondary button-group__button device-control__button", "onClick": (@toggleExpanded), "ref": "dropdownButton"},
              React.createElement("div", {"className": "button__wrap"},
                (@state.name),
                React.createElement("svg", {"className": "icon icon--medium button__icon"},
                  React.createElement("use", {"xlinkHref": "images/icons.svg#icon-arrow-drop-down"})
                )
              )
            ),
            (if @state.rotation then rotate_button else '')
          ),
          (dropdownDevices)
        ),
        React.createElement("div", {"className": "screen-width"}, (@state.width), " × ", (@state.height), " dp"),
        React.createElement("div", {"className": "screen"},
          React.createElement(Frame, {"id": (@props.id), "name": ('XRespond – ' + @state.name)})
        )
      )
    )



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/device.cjsx